var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{staticClass:"text-center align-middle m-0",attrs:{"value":!_vm.isInvalid,"labels":true,"sync":true},on:{"change":function($event){return _vm.toggleInvalid()}}})}
var staticRenderFns = []

export { render, staticRenderFns }